import { GET_STAFF_CARDS_START } from '../../types';

export const get_staff_cards = (payload) => ({
  type: GET_STAFF_CARDS_START,
  payload,
});
